module.exports = __webpack_public_path__ + "img/Doc12b_20110057-020_21d_Minnie Gray.43e7f07c.jpg";